
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_8493_4533)"}},[_c('path',{attrs:{"d":"M6 0a6 6 0 100 12A6 6 0 006 0zm1.193 6.12c-1 1.977-3.213 2.427-4.63 1.588C1.166 6.874.9 5 1.764 3.51c.87-1.5 2.42-2.224 3.938-1.667 1.522.535 2.497 2.294 1.492 4.277z"}}),_c('path',{attrs:{"d":"M4.943 3.03c-.706-.287-1.304-.036-1.569.427a.781.781 0 00-.024.752l-.005.01c-.278.041-.582.209-.757.562-.284.581-.036 1.188.612 1.524.65.337 1.388.203 1.7-.415a.97.97 0 00-.039-.98l.005-.009c.23-.03.541-.18.706-.481.272-.496.081-1.1-.63-1.39zm-.767 2.475a.502.502 0 01-.7.23c-.274-.136-.36-.41-.227-.674.132-.26.407-.36.686-.23.28.128.378.407.241.674zm.66-1.414a.465.465 0 01-.605.186c-.24-.108-.302-.341-.193-.536a.466.466 0 01.6-.19c.24.102.312.336.199.54z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8493_4533"}},[_c('path',{attrs:{"d":"M0 0h12v12H0z"}})])])])
          )
        }
      }
    